(() => {
  'use strict';
  if (window.SE_BUILDER_STARTED) return;
  window.SE_BUILDER_STARTED = true;
  const catalogue = window.SE_SWEET_CATALOGUE || {invalid:true};
  const pileOrder = new Map();
  const portions = new Map();
  const portionCount = () => [...selected.values()].reduce((sum,item) => sum + item.quantity, 0);
  const selectedPicks = () => [...selected.values()].flatMap(item => Array.from({length:item.quantity},() => item));
  let pileSequence = 0, pileSignature = '', pilePack = '', pileQuantities = new Map();
  const repeatSubscription = (() => {
    try { return JSON.parse(document.getElementById('se-builder-selling-plans')?.textContent || '{"variants":{}}'); }
    catch { return {variants:{}}; }
  })();
  let purchaseMode = 'once', deliveryFrequency = 'monthly';
  const packingAsset = name => window.SE_BUILDER_ASSETS[name];
  const cleanSweets = {"Fried Eggs":{"asset":"sweets-a-600.webp","box":[6.22,10.447,41.388,33.493],"atlasRatio":1.0},"Fizzy Bubblegum Bottles":{"asset":"sweets-a-600.webp","box":[59.25,5.104,32.217,42.185],"atlasRatio":1.0},"Cola Bottles":{"asset":"sweets-a-600.webp","box":[9.968,53.748,34.051,40.829],"atlasRatio":1.0},"Fizzy Rainbow Belts":{"asset":"sweets-a-600.webp","box":[53.668,56.699,44.577,38.278],"atlasRatio":1.0},"Fizzy Peach Rings (VG)":{"asset":"sweets-b-600.webp","box":[5.423,5.662,42.743,40.67],"atlasRatio":1.0},"Fizzy Cherries":{"asset":"sweets-b-600.webp","box":[53.987,4.864,42.743,41.148],"atlasRatio":1.0},"Haribo Cherries":{"asset":"sweets-b-600.webp","box":[6.38,51.276,43.62,42.026],"atlasRatio":1.0},"Blue Raspberry Pencils":{"asset":"sweets-b-600.webp","box":[58.373,52.871,36.364,41.228],"atlasRatio":1.0},"Strawberry Pencils":{"asset":"sweets-c-600.webp","box":[4.306,4.067,40.431,39.234],"atlasRatio":1.0},"Fizzy Strawbs (VG)":{"asset":"sweets-c-600.webp","box":[57.974,3.828,37.879,40.75],"atlasRatio":1.0},"Sour Dummies":{"asset":"sweets-c-600.webp","box":[5.024,55.662,44.737,36.124],"atlasRatio":1.0},"Sour Worms":{"asset":"sweets-c-600.webp","box":[53.509,53.03,43.301,41.388],"atlasRatio":1.0},"Strawbs (VG)":{"asset":"sweets-04-720.webp","box":[6.722,3.499,22.284,27.808],"atlasRatio":0.75},"Tongue Painters (VG)":{"asset":"sweets-04-720.webp","box":[37.753,3.499,24.954,27.164],"atlasRatio":0.75},"Haribo Terrific Turtles":{"asset":"sweets-04-720.webp","box":[68.508,7.459,29.098,22.376],"atlasRatio":0.75},"Haribo Friendship Rings":{"asset":"sweets-04-720.webp","box":[3.959,37.201,26.427,26.151],"atlasRatio":0.75},"Haribo Heart Throbs":{"asset":"sweets-04-720.webp","box":[38.766,38.858,23.849,22.928],"atlasRatio":0.75},"Jelly Sharks":{"asset":"sweets-04-720.webp","box":[67.68,39.779,31.308,21.731],"atlasRatio":0.75},"White Chocolate Stars":{"asset":"sweets-04-720.webp","box":[2.855,68.692,28.177,27.072],"atlasRatio":0.75},"Blue Raspberry Slices":{"asset":"sweets-04-720.webp","box":[35.635,70.35,29.466,26.519],"atlasRatio":0.75},"Sour Bears":{"asset":"sweets-04-720.webp","box":[73.573,68.14,20.902,29.19],"atlasRatio":0.75},"Gummy Bears":{"asset":"sweets-04-720.webp","box":[8.379,100.368,17.495,28.545],"atlasRatio":0.75},"Fizzy Octopus":{"asset":"sweets-04-720.webp","box":[35.083,100.552,29.926,27.993],"atlasRatio":0.75},"Fizzy Cherry Cola Bottles (VG)":{"asset":"sweets-04-720.webp","box":[75.506,100.184,15.378,28.729],"atlasRatio":0.75},"Fizzy Cola Bottles":{"asset":"sweets-05-720.webp","box":[9.208,2.67,13.812,28.729],"atlasRatio":0.75},"Strawberry Dracula Teeth (VG)":{"asset":"sweets-05-720.webp","box":[36.648,8.564,25.967,19.89],"atlasRatio":0.75},"Fizzy Strawberry Dracula Teeth (VG)":{"asset":"sweets-05-720.webp","box":[69.521,8.564,27.716,18.6],"atlasRatio":0.75},"Pizza Slices":{"asset":"sweets-05-720.webp","box":[2.578,36.556,23.941,26.427],"atlasRatio":0.75},"Cherry Lips":{"asset":"sweets-05-720.webp","box":[35.912,41.16,27.624,18.048],"atlasRatio":0.75},"Baby Dolphins":{"asset":"sweets-05-720.webp","box":[69.705,39.871,28.821,22.468],"atlasRatio":0.75},"Gummy Worms":{"asset":"sweets-05-720.webp","box":[2.578,70.626,28.637,24.862],"atlasRatio":0.75},"Sour Rainbow Shocks (VG)":{"asset":"sweets-05-720.webp","box":[36.188,69.521,28.177,24.954],"atlasRatio":0.75},"Fizzy Blue Raspberry Shocks":{"asset":"sweets-05-720.webp","box":[71.271,72.007,26.059,22.007],"atlasRatio":0.75},"Fizzy Strawberry Shocks":{"asset":"sweets-05-720.webp","box":[3.867,103.315,26.888,22.744],"atlasRatio":0.75},"Blue Raspberry Rings":{"asset":"sweets-05-720.webp","box":[37.477,102.118,25.414,23.941],"atlasRatio":0.75},"Fruit Rings":{"asset":"sweets-05-720.webp","box":[70.902,102.118,25.783,24.033],"atlasRatio":0.75},"Blue Rasberrry Twists":{"asset":"sweets-06-720.webp","box":[5.341,5.709,24.494,23.849],"atlasRatio":0.75},"Strawberry Twists":{"asset":"sweets-06-720.webp","box":[37.661,5.801,24.401,24.033],"atlasRatio":0.75},"Apple Rings":{"asset":"sweets-06-720.webp","box":[69.245,5.064,26.427,25.875],"atlasRatio":0.75},"Jelly Brains":{"asset":"sweets-06-720.webp","box":[4.788,37.293,25.506,24.309],"atlasRatio":0.75},"Sugared Bananas":{"asset":"sweets-06-720.webp","box":[35.912,37.293,28.269,23.757],"atlasRatio":0.75},"Haribo Yellow Bellies":{"asset":"sweets-detail-v2-600.webp","box":[7.018,50.0,38.517,44.577],"atlasRatio":1.0},"Haribo Rhubarb & Custards":{"asset":"sweets-06-720.webp","box":[4.512,72.376,25.875,20.258],"atlasRatio":0.75},"Strawberry Milkshake Bottles (VG)":{"asset":"sweets-06-720.webp","box":[42.357,68.785,14.18,27.164],"atlasRatio":0.75},"Haribo Rotella":{"asset":"sweets-06-720.webp","box":[69.521,69.521,26.335,26.059],"atlasRatio":0.75},"Bunch of Grapes":{"asset":"sweets-06-720.webp","box":[5.525,100.0,23.941,29.19],"atlasRatio":0.75},"Fizzy Blue Raspberries (VG)":{"asset":"sweets-06-720.webp","box":[39.319,102.21,21.271,25.967],"atlasRatio":0.75},"Fizzy Blue Raspberry Laces":{"asset":"sweets-06-720.webp","box":[68.785,103.775,27.901,22.836],"atlasRatio":0.75},"Haribo Giant Sour Suckers":{"asset":"sweets-07-720.webp","box":[4.512,3.131,26.796,29.19],"atlasRatio":0.75},"Fizzy Chips":{"asset":"sweets-07-720.webp","box":[36.832,6.722,25.875,22.652],"atlasRatio":0.75},"Haribo Freaky Fish":{"asset":"sweets-07-720.webp","box":[67.403,6.63,30.939,23.573],"atlasRatio":0.75},"Fizzy Bubblegum Bears (VG)":{"asset":"sweets-07-720.webp","box":[7.919,36.648,17.403,27.072],"atlasRatio":0.75},"Blackberry & Raspberry Jellies":{"asset":"sweets-detail-v2-600.webp","box":[11.164,10.048,30.064,31.818],"atlasRatio":1.0},"Tropical Frogs":{"asset":"sweets-07-720.webp","box":[69.705,36.74,27.532,26.151],"atlasRatio":0.75},"Strawberry Bon Bons":{"asset":"sweets-07-720.webp","box":[7.274,71.823,20.902,20.442],"atlasRatio":0.75},"Blue Raspberry Bon Bons":{"asset":"sweets-07-720.webp","box":[39.227,71.731,21.363,21.087],"atlasRatio":0.75},"Toffee Bon Bons":{"asset":"sweets-07-720.webp","box":[72.192,71.915,20.626,20.35],"atlasRatio":0.75},"Meerkats (VG)":{"asset":"sweets-07-720.webp","box":[11.602,100.0,12.247,30.295],"atlasRatio":0.75},"Strawberry & Banana Milkshake Bottles":{"asset":"sweets-07-720.webp","box":[42.357,100.0,17.772,29.19],"atlasRatio":0.75},"Gummy Crocodiles":{"asset":"sweets-07-720.webp","box":[68.048,100.0,29.374,28.453],"atlasRatio":0.75},"Pineapples":{"asset":"sweets-08-720.webp","box":[7.735,2.947,18.508,29.466],"atlasRatio":0.75},"Pineapple Rings":{"asset":"sweets-08-720.webp","box":[35.451,6.169,28.729,26.427],"atlasRatio":0.75},"Watermelon Bites":{"asset":"sweets-08-720.webp","box":[70.81,6.077,26.151,24.678],"atlasRatio":0.75},"Sour Kiwi Slices":{"asset":"sweets-08-720.webp","box":[4.052,38.49,25.783,25.138],"atlasRatio":0.75},"Wild Strawberries":{"asset":"sweets-08-720.webp","box":[40.239,37.569,20.35,26.059],"atlasRatio":0.75},"Fizzy Rainbow Pencils":{"asset":"sweets-08-720.webp","box":[70.442,39.134,26.888,24.401],"atlasRatio":0.75},"Fizzy Blue Bears (VG)":{"asset":"sweets-08-720.webp","box":[5.801,68.508,21.271,28.453],"atlasRatio":0.75},"Fizzy Apple Belts":{"asset":"sweets-08-720.webp","box":[34.346,68.416,29.466,28.177],"atlasRatio":0.75},"Milk Chocolate Frogs":{"asset":"sweets-08-720.webp","box":[66.667,74.586,31.86,18.6],"atlasRatio":0.75},"Sour Lime Slices":{"asset":"sweets-08-720.webp","box":[2.855,100.737,27.256,28.637],"atlasRatio":0.75},"Sour Strawberry Slices":{"asset":"sweets-08-720.webp","box":[36.372,100.921,26.703,28.637],"atlasRatio":0.75},"Pink & White Mice":{"asset":"sweets-08-720.webp","box":[69.89,105.064,27.716,21.087],"atlasRatio":0.75},"Sour Cola Rings":{"asset":"sweets-09-720.webp","box":[5.249,7.274,24.586,23.02],"atlasRatio":0.75},"Fizzy Tongue Painter Dummies (VG)":{"asset":"sweets-09-720.webp","box":[36.096,2.026,26.519,30.295],"atlasRatio":0.75},"Fizzy Tongue Painter Dummies":{"asset":"sweets-09-720.webp","box":[36.096,2.026,26.519,30.295],"atlasRatio":0.75},"Sour Volcanoes":{"asset":"sweets-09-720.webp","box":[68.785,6.077,28.269,25.414],"atlasRatio":0.75},"Strawberry Dreams":{"asset":"sweets-09-720.webp","box":[4.88,38.306,25.875,23.757],"atlasRatio":0.75},"Blackcurrant Rings":{"asset":"sweets-09-720.webp","box":[37.109,38.398,25.691,24.586],"atlasRatio":0.75},"Fizzy Blue Soda Pencils":{"asset":"sweets-09-720.webp","box":[70.258,37.753,26.151,25.967],"atlasRatio":0.75},"Sour Fried Eggs":{"asset":"sweets-09-720.webp","box":[4.42,70.166,25.322,24.401],"atlasRatio":0.75},"Fizzy Funky Fish":{"asset":"sweets-09-720.webp","box":[34.899,72.744,30.387,20.81],"atlasRatio":0.75},"Strawberry Pencils (mini)":{"asset":"sweets-09-720.webp","box":[73.481,73.757,22.007,18.692],"atlasRatio":0.75},"Fizzy Blue Raspberry Pencils (mini)":{"asset":"sweets-09-720.webp","box":[6.262,105.249,22.744,20.81],"atlasRatio":0.75},"Giant Blue Raspberry Dolphins":{"asset":"sweets-09-720.webp","box":[36.004,101.105,28.913,28.177],"atlasRatio":0.75},"Giant Fizzy Bubblegum Bottles":{"asset":"sweets-09-720.webp","box":[70.534,100.0,25.506,30.571],"atlasRatio":0.75},"Giant Haribo Cola Bottles":{"asset":"sweets-10-720.webp","box":[7.551,2.302,20.258,30.939],"atlasRatio":0.75},"Jelly Skulls":{"asset":"sweets-detail-v2-600.webp","box":[59.888,6.699,29.984,37.64],"atlasRatio":1.0},"Fizzy Blue Skulls":{"asset":"sweets-10-720.webp","box":[73.389,5.801,20.626,25.783],"atlasRatio":0.75},"Fizzy Red Skulls":{"asset":"sweets-10-720.webp","box":[6.262,36.74,21.271,26.888],"atlasRatio":0.75},"Haribo Jelly Babies":{"asset":"sweets-10-720.webp","box":[42.449,36.28,16.022,27.901],"atlasRatio":0.75},"Vimto Chew Bar":{"asset":"sweets-10-720.webp","box":[67.311,44.751,31.308,8.932],"atlasRatio":0.75},"Tango Shocker Fizzy Blue Raspberry Chew Bar":{"asset":"sweets-10-720.webp","box":[1.657,76.243,30.571,9.024],"atlasRatio":0.75},"Refreshers Sour Apple Chew Bar":{"asset":"sweets-10-720.webp","box":[34.899,75.875,30.295,9.3],"atlasRatio":0.75},"Fizzy Strawberry Belts":{"asset":"sweets-10-720.webp","box":[68.969,70.626,29.558,21.455],"atlasRatio":0.75},"Trolli Milky Cow":{"asset":"sweets-detail-v2-600.webp","box":[52.472,57.735,44.338,32.057],"atlasRatio":1.0},"Sour Pineapple Skulls":{"asset":"sweets-10-720.webp","box":[39.227,100.0,22.284,26.151],"atlasRatio":0.75},"Sour Apple Skulls":{"asset":"sweets-10-720.webp","box":[73.112,100.0,23.204,27.072],"atlasRatio":0.75},"Sour Mango Skulls":{"asset":"sweets-11-720.webp","box":[6.446,4.052,21.731,26.151],"atlasRatio":0.75},"Sour Strawberry Skulls":{"asset":"sweets-11-720.webp","box":[38.95,4.052,21.639,26.151],"atlasRatio":0.75},"Blackcurrant Pencils":{"asset":"sweets-11-720.webp","box":[70.902,7.459,26.243,21.087],"atlasRatio":0.75},"Watermelon Slices":{"asset":"sweets-11-720.webp","box":[4.328,36.28,27.808,26.427],"atlasRatio":0.75},"Strawberry Dummies (VG)":{"asset":"sweets-11-720.webp","box":[39.595,35.82,20.074,27.256],"atlasRatio":0.75},"Jelly Pink Pigs":{"asset":"sweets-11-720.webp","box":[67.403,40.608,30.11,19.521],"atlasRatio":0.75},"Bubs Sour Raspberry & Lemon Skulls (VG)":{"asset":"sweets-11-720.webp","box":[6.446,69.705,23.481,27.624],"atlasRatio":0.75},"Pink & White Chocolate Ice Cream Cones":{"asset":"sweets-11-720.webp","box":[39.687,70.166,22.192,26.335],"atlasRatio":0.75}};
  const icon = (name, cls = '') => {
    const paths = {
      arrow: '<path d="M4 12h15m-6-6 6 6-6 6"/>',
      search: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 4 4"/>',
      plus: '<path d="M12 5v14M5 12h14"/>',
      minus: '<path d="M5 12h14"/>',
      check: '<path d="m5 12 4 4L19 6"/>',
      close: '<path d="m6 6 12 12M18 6 6 18"/>',
      chevron: '<path d="m6 15 6-6 6 6"/>',
      leaf: '<path d="M20 4C9 1 2 8 5 15c7 5 15-1 15-11Z"/><path d="m4 21 10-11"/>',
      fizzy: '<path d="m13 2-8 12h6l-1 8 9-13h-6l1-7Z"/>',
      fruit: '<path d="M12 7c-9-5-11 10-4 13 2 1 3-1 4-1s2 2 4 1c7-3 5-18-4-13Z"/><path d="M12 7V3m0 3c2-4 5-4 6-4"/>',
      chocolate: '<rect x="5" y="3" width="14" height="18" rx="3"/><path d="M5 9h14M5 15h14M12 3v18"/>',
      candy: '<path d="m7 8-5-3 1 7-1 7 5-3m10-8 5-3-1 7 1 7-5-3"/><rect x="6" y="6" width="12" height="12" rx="5"/><path d="m9 7 6 10"/>',
      bag: '<path d="M5 8h14l1 13H4L5 8Z"/><path d="M8 9V6a4 4 0 0 1 8 0v3"/>'
    };
    return `<svg class="sb-icon ${cls}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[name] || paths.candy}</svg>`;
  };
  const escape = value => String(value).replace(/[&<>"']/g, x => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[x]));
  const label = value => catalogue?.entries?.get(value)?.name || value.replace(/\s*\(VG\)/ig, '').trim();
  const money = p => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP',maximumFractionDigits:p % 100 ? 2 : 0}).format(p / 100);
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  let root, native, group, items = [], variant, sizes = [], selected = new Map(), category = 'all', changing = false, busy = false, lastGroup = '', lastAvailability = '', toastTimer;
  const ui = s => root.querySelector(s);
  const uis = s => root.querySelectorAll(s);
  const visibleGroup = () => catalogue.group;
  const nativeSelect = () => catalogue.select;
  const nativeForm = () => catalogue.form;
  const readRules = g => {
    const rules = g?.dataset.validate || '';
    const required = Number(rules.match(/max_s:(\d+)/)?.[1]);
    return {min:required,max:required};
  };
  const rules = () => readRules(group);
  const announce = message => {
    ui('.sb-live').textContent = message;
    ui('.sb-toast').textContent = message;
    ui('.sb-toast').classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => ui('.sb-toast').classList.remove('is-visible'), 3600);
  };

  function parseItems() {
    return catalogue.items();
  }

  function readSizes() {
    return catalogue.sizes;
  }

  function mount() {
    if (catalogue?.invalid) return false;
    group = visibleGroup();
    if (!group || !nativeSelect() || !nativeForm() || !readRules(group).min) return false;
    sizes = readSizes();
    if (sizes.length !== 4) return false;
    const main = document.getElementById('MainContent');
    root = main.querySelector('[data-se-builder-shell]');
    if (!root) return false;
    native = main.querySelector(':scope > .sb-native');
    if (!native) {
      native = document.createElement('div');
      native.className = 'sb-native';
      [...main.childNodes].filter(node => node !== root).forEach(node => native.append(node));
      main.append(native);
    }
    const mobileLayout = matchMedia('(max-width:900px)');
    const arrangePreview = () => {
      if (mobileLayout.matches) ui('.sb-toolbar').prepend(ui('.sb-pile-preview'));
      else ui('.sb-summary-heading').after(ui('.sb-pile-preview'));
    };
    arrangePreview();
    mobileLayout.addEventListener('change',arrangePreview);
    ui('.sb-drawer h2').id='sb-drawer-title';
    ui('.sb-drawer').setAttribute('aria-labelledby','sb-drawer-title');
    ui('.sb-confirm h2').id='sb-confirm-title';
    ui('.sb-confirm').setAttribute('aria-labelledby','sb-confirm-title');
    prepareConfirmation();
    document.body.classList.add('sb-page');
    native.setAttribute('aria-hidden','true');
    native.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el => el.setAttribute('tabindex','-1'));
    document.querySelector('.se-logo, .se-nav__logo')?.setAttribute('href','/');
    root.querySelectorAll('[data-sb-bootstrap-disabled]').forEach(control => {control.disabled=false;control.removeAttribute('data-sb-bootstrap-disabled');});
    bind();
    restoreDraft();
    sync(true);
    root.classList.remove('sb-is-loading');
    root.setAttribute('aria-busy','false');
    root.dataset.ready='true';
    root.querySelector('.sb-loading-status')?.remove();
    performance.mark('se-builder-ready');
    document.addEventListener('change', e => {
      if (native.contains(e.target) && !changing) setTimeout(() => sync(false),80);
    });
    window.addEventListener('pageshow', () => sync(true));
    return true;
  }

  function restoreDraft() {
    try {
      const draft=JSON.parse(sessionStorage.getItem('sweet-enough-builder-draft')||'null');
      const current=sizes.find(size=>size.value===nativeSelect()?.value);
      if(!draft || String(draft.variant)!==String(current?.id) || !Array.isArray(draft.picks))return;
      const parsedItems=parseItems(), restored=new Map();
      let remaining=readRules(group).max;
      for(const pick of draft.picks) {
        const matched = catalogue && catalogue.items().find(item => item.name===pick.name || item.orderValue===pick.name);
        if (matched) pick.name = matched.name;
        if(typeof pick.name!=='string' || !Number.isInteger(pick.quantity) || pick.quantity<1 || restored.has(pick.name) || !parsedItems.some(item=>item.name===pick.name && item.available))continue;
        const quantity=Math.min(pick.quantity,remaining);
        if(quantity)restored.set(pick.name,quantity);
        remaining-=quantity;
      }
      changing=true;
      for(const item of parsedItems)if(item.input.checked!==restored.has(item.name))item.input.click();
      portions.clear();
      for(const [name,quantity] of restored)portions.set(name,quantity);
      purchaseMode=draft.purchase==='subscribe' && repeatSubscription.variants[current.weight]?.plans?.[draft.frequency==='fortnightly'?'fortnightly':'monthly']?'subscribe':'once';
      deliveryFrequency=draft.frequency==='fortnightly'?'fortnightly':'monthly';
    } catch {} finally {changing=false;}
  }

  function saveDraft() {
    try {sessionStorage.setItem('sweet-enough-builder-draft',JSON.stringify({variant:variant.id,picks:[...selected.values()].map(item=>({name:item.name,quantity:item.quantity})),purchase:purchaseMode,frequency:deliveryFrequency}));}catch {}
  }

  function sync(rebuild = false) {
    if (changing) return;
    const active = visibleGroup();
    if (!active) return;
    group = active;
    if (catalogue) sizes = readSizes();
    variant = sizes.find(v => v.value === nativeSelect()?.value) || sizes[1];
    items = parseItems();
    const checked = items.filter(x => x.input.checked && x.available);
    const names = new Set(checked.map(x => x.name));
    for (const name of portions.keys()) if (!names.has(name)) portions.delete(name);
    selected = new Map(checked.map(x => {
      const quantity = portions.get(x.name) || 1;
      portions.set(x.name,quantity);
      return [x.name,{...x,quantity}];
    }));
    if (!subscriptionPlan()) purchaseMode='once';
    syncRecipeProperty();
    const groupChanged = lastGroup !== group.id;
    const availability = items.map(item => `${item.name}:${item.available}`).join('|');
    const availabilityChanged = availability !== lastAvailability;
    lastGroup = group.id;
    lastAvailability = availability;
    uis('[data-size]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.size===String(variant.id))));
    ui('.sb-size-help').innerHTML = `Choose <strong>${rules().max} picks</strong> for your ${escape(variant.weight)} ${escape(variant.pack)}.`;
    ui('.sb-summary-size').textContent = `${variant.weight} ${variant.pack}`;
    if (rebuild || groupChanged || availabilityChanged) renderGrid();
    else updateCards();
    renderSummary();
    renderPile();
  }

  function matches(item) {
    if (catalogue) return item.available && (category==='all' || category==='selected' && selected.has(item.name) || item.categories.includes(category));
    const n = item.title.toLowerCase();
    const fizzy = /fizzy|sour/.test(n);
    const chocolate = /chocolate|pink & white mice/.test(n);
    return item.available && (category==='all' || category==='vegan' && item.vegan || category==='selected' && selected.has(item.name) || category==='fizzy' && fizzy || category==='chocolate' && chocolate || category==='fruity' && !chocolate && /straw|cherr|peach|rasp|blackcurrant|watermelon|fruit|apple|grape|pineapple|banana|kiwi|mango|lime|tropical/.test(n));
  }

  let gridPhotoObserver;
  function selectionPhoto(url, width) {
    try {
      const image = new URL(url, location.origin);
      const shopifyPhoto = /(?:^|\.)shopify\.com$/.test(image.hostname) || image.hostname === location.hostname;
      if (!shopifyPhoto || !/\/(?:cdn\/shop\/files|s\/files)\//.test(image.pathname)) return url;
      image.searchParams.set('width', String(width));
      image.searchParams.delete('height');
      return image.href;
    } catch { return url; }
  }
  function photoAttributes(item, eager) {
    const src = selectionPhoto(item.url, 320);
    const candidates = [160,240,320,480].map(width=>`${selectionPhoto(item.url,width)} ${width}w`).join(', ');
    const sizes = '(max-width: 600px) 24vw, (max-width: 900px) 22vw, (max-width: 1200px) 13vw, 165px';
    return `${eager?'':'data-photo-'}src="${escape(src)}" ${eager?'':'data-photo-'}srcset="${escape(candidates)}" sizes="${sizes}"`;
  }
  function observeGridPhotos() {
    gridPhotoObserver?.disconnect();
    const load = image => {
      image.srcset = image.dataset.photoSrcset;
      image.src = image.dataset.photoSrc;
      delete image.dataset.photoSrcset; delete image.dataset.photoSrc;
    };
    const deferred = uis('img[data-photo-src]');
    if (!('IntersectionObserver' in window)) {deferred.forEach(load);return;}
    gridPhotoObserver = new IntersectionObserver(entries=>entries.forEach(entry=>{
      if (!entry.isIntersecting) return;
      load(entry.target);gridPhotoObserver.unobserve(entry.target);
    }), {rootMargin:'600px 0px'});
    deferred.forEach(image=>gridPhotoObserver.observe(image));
  }

  function renderGrid() {
    const featured = ['Fizzy Cherries','Fried Eggs','Fizzy Bubblegum Bottles','Fizzy Rainbow Belts','Cola Bottles','Strawberry Pencils','White Chocolate Stars','Sour Worms'];
    const ordered = [...items].sort((a,b) => {
      if (catalogue) return a.order-b.order || a.title.localeCompare(b.title);
      if (a.available !== b.available) return Number(b.available)-Number(a.available);
      const aRank = featured.indexOf(a.title), bRank = featured.indexOf(b.title);
      return (aRank<0?1000:aRank)-(bRank<0?1000:bRank);
    });
    const filtered = ordered.filter(matches);
    ui('.sb-grid').innerHTML = filtered.map((item,index) => `<article class="sb-sweet" data-sweet="${escape(item.name)}"><button type="button" class="sb-sweet-pick" data-increase="${escape(item.name)}" aria-label="Add ${escape(item.title)}"><span class="sb-sweet-photo"><img ${photoAttributes(item,index<8)} width="400" height="400" loading="eager" decoding="async" alt="">${item.vegan?`<span class="sb-vg" title="Labelled vegan">VG</span>`:''}<span class="sb-sweet-tick">${icon('check')}</span></span><span class="sb-sweet-bottom"><span class="sb-sweet-name">${escape(item.title)}</span></span></button><div class="sb-card-controls"><button class="sb-sweet-add" type="button" data-increase="${escape(item.name)}">Add ${icon('plus')}</button>${quantityControls(item)}</div></article>`).join('');
    observeGridPhotos();
    ui('.sb-no-results').hidden = filtered.length>0;
    ui('.sb-no-results h3').textContent = category==='selected' ? 'Your mix starts with a favourite.' : 'No sweets in this category';
    ui('.sb-no-results p').textContent = category==='selected' ? 'Choose from All sweets, then come back here to see your picks.' : 'Choose a different category to see more sweets.';
    ui('.sb-sweet-menu').scrollTop=0;
    updateCards();
  }

  function updateCards() {
    uis('[data-sweet]').forEach(card => {
      const chosen = selected.has(card.dataset.sweet);
      const item = items.find(item => item.name === card.dataset.sweet);
      const unavailable = !item?.available;
      card.classList.toggle('is-chosen',chosen);
      card.classList.toggle('is-unavailable',unavailable);
      card.querySelector('.sb-sweet-pick').setAttribute('aria-label',`${unavailable?'Sold out:':'Add a pick of'} ${label(card.dataset.sweet)}`);
      card.querySelector('.sb-sweet-add').innerHTML = unavailable ? 'Sold out' : `Add ${icon('plus')}`;
      card.querySelector('.sb-sweet-add').hidden = chosen;
      card.querySelector('.sb-quantity').hidden = !chosen;
      card.querySelector('[data-decrease]').disabled = !chosen || busy || changing;
      card.querySelector('output').textContent = selected.get(item?.name)?.quantity || 0;
      card.querySelectorAll('[data-increase]').forEach(button => button.disabled = unavailable || busy || changing || portionCount()>=rules().max);
      let soldOut = card.querySelector('.sb-sold-out');
      if (unavailable && !soldOut) {
        soldOut = document.createElement('span');
        soldOut.className = 'sb-sold-out';
        soldOut.textContent = 'Sold out';
        card.querySelector('.sb-sweet-photo').append(soldOut);
      } else if (!unavailable) soldOut?.remove();
    });
    if (category==='selected') renderGridAfterSelection();
  }

  function renderGridAfterSelection() {
    uis('[data-sweet]').forEach(card => { card.hidden = !selected.has(card.dataset.sweet); });
    ui('.sb-no-results').hidden = selected.size>0;
  }

  function selectionRows() {
    return [...selected.values()].map(item => `<div class="sb-selected-row sb-review-card"><img src="${escape(item.url)}" width="80" height="64" alt=""><span title="${escape(item.title)}">${escape(item.title)}</span><div class="sb-review-card-controls"><b class="sb-row-quantity" aria-label="${item.quantity} ${item.quantity===1?'pick':'picks'}">×${item.quantity}</b><button type="button" data-decrease="${escape(item.name)}" data-summary-decrease="${escape(item.name)}" aria-label="Remove one ${escape(item.title)}">${icon('minus')}</button></div></div>`).join('');
  }

  function quantityControls(item) {
    return `<div class="sb-quantity" role="group" aria-label="Picks of ${escape(item.title)}"><button type="button" data-decrease="${escape(item.name)}" aria-label="Less ${escape(item.title)}">${icon('minus')}</button><output aria-label="Picks of ${escape(item.title)}">${selected.get(item.name)?.quantity || 0}</output><button type="button" data-increase="${escape(item.name)}" aria-label="More ${escape(item.title)}">${icon('plus')}</button></div>`;
  }

  function recipeSummary() {
    return [...selected.values()].map(item => `${item.title} ×${item.quantity}`).join(', ');
  }

  function syncRecipeProperty() {
    const form = nativeForm();
    if (!form) return;
    form.querySelectorAll('[data-sb-proportions],[data-sb-pick],[data-sb-recipe]').forEach(input => input.remove());
    const recipe = recipeSummary();
    if (!recipe) return;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = 'properties[Your sweets]';
    input.dataset.sbRecipe = ''; input.value = recipe; form.append(input);
  }

  function renderSummary() {
    const focused = document.activeElement;
    const focusArea = focused?.closest('.sb-selection-list,.sb-drawer-list,.sb-pick-strip');
    const focusPick = focusArea && focused.dataset.removePick;
    const focusSweet = focusArea && focused.dataset.summaryDecrease;
    const {min,max} = rules(), count = portionCount();
    const remaining = count<min ? `Pick ${min-count} more to make your mix.` : count===max ? 'Your mix is full. Looking sweet!' : `Ready when you are. Room for ${max-count} more.`;
    ui('.sb-count').textContent = `${count} of ${max} picks`;
    ui('.sb-portion-help p').textContent = `Fill your ${max} picks with any combination of sweets. Use + to pick the same sweet more than once. For example, 3 picks of cola bottles count as 3 of your ${max} picks.`;
    ui('.sb-count-helper').textContent = 'Repeats count';
    ui('.sb-progress span').style.transform = `scaleX(${Math.min(count/max,1)})`;
    ui('.sb-selection-list').innerHTML = count ? selectionRows() : `<div class="sb-empty-mix">${icon('candy')}<strong>Good things start here.</strong><span>Tap your favourites to<br>make this mix yours.</span></div>`;
    ui('.sb-drawer-list').innerHTML = count ? selectionRows() : '<p class="sb-empty-drawer">Your favourites will appear here as you pick.</p>';
    ui('.sb-remaining').textContent = remaining;
    ui('.sb-remaining').hidden=count===max;
    ui('.sb-drawer-remaining').textContent = remaining;
    ui('.sb-dock-count').textContent = `${count} of ${max} picks · ${money(purchasePrice())}`;
    ui('.sb-dock-help').textContent = count<min ? `Choose ${min-count} more to continue` : purchaseMode==='subscribe' ? `${deliveryFrequency==='monthly'?'Monthly':'Every 2 weeks'} · Review your mix` : 'Ready to review your mix';
    ui('.sb-drawer-rule').innerHTML = `<strong>${escape(variant.weight)} ${escape(variant.pack)}</strong><span>${count} of ${max} picks selected</span>`;
    ui('.sb-drawer-remaining').hidden=count===max;
    ui('.sb-mini-sweets').innerHTML = '<svg viewBox="70 0 420 330" aria-hidden="true"><use href="#sb-package-content"/></svg>';
    renderPurchase(count,max);
    saveDraft();
    ui('.sb-picks-count').textContent = count ? ` ${count}` : '';
    ui('.sb-picked-tray').hidden = !count;
    ui('.sb-pick-strip').innerHTML = selectedPicks().map((item,index) => `<div class="sb-picked-chip" role="listitem"><img src="${escape(item.url)}" width="32" height="32" alt=""><span>${escape(item.title)}</span><button type="button" data-remove-pick="${index}" aria-label="Remove ${escape(item.title)}, pick ${index+1}">${icon('close')}</button></div>`).join('');
    if (focusSweet) {
      const buttons=[...focusArea.querySelectorAll('[data-summary-decrease]')];
      (buttons.find(button=>button.dataset.summaryDecrease===focusSweet)||buttons.at(-1)||ui('.sb-tray-toggle'))?.focus({preventScroll:true});
    }
    if (focusPick !== false && focusPick !== undefined && focusPick !== null) {
      const buttons = [...focusArea.querySelectorAll('[data-remove-pick]')];
      (buttons.find(button => button.dataset.removePick===focusPick) || buttons.at(-1) || ui('.sb-tray-toggle'))?.focus({preventScroll:true});
    }
  }

  function subscriptionPlan() {
    const repeat = repeatSubscription.variants?.[variant?.weight];
    const plan = repeat?.plans?.[deliveryFrequency];
    if (!repeat?.available || String(repeat.id)!==String(variant?.id) || !plan?.id || !Number.isInteger(plan.price) || plan.price<0) return null;
    return plan;
  }

  function purchasePrice() {
    return purchaseMode==='subscribe' ? subscriptionPlan()?.price ?? variant.price : variant.price;
  }

  function renderPurchase(count,max) {
    root.dataset.purchase=purchaseMode;
    const repeat = subscriptionPlan();
    root.dataset.repeatAvailable=String(Boolean(repeat));
    uis('[data-purchase-mode]').forEach(input => {
      input.checked=input.value===purchaseMode;
      input.disabled=busy || changing || input.value==='subscribe' && !repeat;
      input.closest('label').classList.toggle('is-selected',input.checked);
      input.closest('label').classList.toggle('is-disabled',input.disabled);
      if(input.value==='subscribe')input.setAttribute('aria-expanded',String(input.checked));
    });
    uis('.sb-once-price').forEach(el=>el.textContent=money(variant.price));
    uis('.sb-repeat-price').forEach(el=>el.textContent=repeat?money(repeat.price):'');
    uis('.sb-repeat-was').forEach(el=>el.textContent=money(variant.price));
    uis('.sb-subscription-saving').forEach(el=>el.textContent=repeat?(el.dataset.savingTemplate || 'Save __SAVING__ each delivery').replace('__SAVING__',money(variant.price-repeat.price)):'');
    uis('.sb-subscription-teaser').forEach(el=>el.hidden=!repeat);
    uis('.sb-purchase-repeat').forEach(el=>el.hidden=!repeat);
    uis('.sb-subscription-details').forEach(el=>el.hidden=purchaseMode!=='subscribe');
    uis('.sb-recurring-charge').forEach(el=>el.textContent=(el.dataset.chargeTemplate || '__PRICE__ __FREQUENCY__. Shipping extra.').replace('__PRICE__',money(purchasePrice())).replace('__FREQUENCY__',el.dataset[deliveryFrequency] || (deliveryFrequency==='monthly'?'every month':'every 2 weeks')));
    uis('.sb-recurring-saving').forEach(el=>el.textContent=`Save ${money(variant.price-(repeat?.price||variant.price))} per delivery. Shipping extra.`);
    uis('[data-frequency]').forEach(input=>{input.checked=input.value===deliveryFrequency;input.disabled=busy||changing||!repeatSubscription.variants?.[variant.weight]?.plans?.[input.value];});
    ui('.sb-summary-picks-count').textContent=count;
    uis('.sb-steps [data-step]').forEach(button=>{
      const current=button.dataset.step===(count===max?'review':'sweets');
      if(current)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');
      button.classList.toggle('is-complete',button.dataset.step==='size'||button.dataset.step==='sweets'&&count===max);
    });
    uis('.sb-price').forEach(el=>el.textContent=money(purchasePrice()));
    uis('.sb-add').forEach(button=>{
      const review=count===max && button.closest('.sb-mobile-dock');
      const incomplete=count<max;
      button.dataset.sbAction=incomplete?'pick':review?'review':'add';
      button.disabled=changing || busy || count>max || !variant.available || !incomplete && !review && purchaseMode==='subscribe' && !repeat;
      button.querySelector('span').textContent=busy?'Adding…':incomplete?count?`Choose ${max-count} more`:'Choose my sweets':review?'Review my mix':purchaseMode==='subscribe'?'Subscribe to my mix':'Add my mix';
    });
  }

  function openTray() {
    ui('.sb-drawer').showModal();
    ui('.sb-tray-toggle').setAttribute('aria-expanded','true');
  }

  function goToSweets() {
    closeTray();
    if (category==='selected' || !items.some(matches)) {
      category='all';
      uis('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category==='all')));
      renderGrid();
    }
    const mobilePicker=matchMedia('(max-width:900px)').matches;
    ui(mobilePicker?'.sb-catalogue':'.sb-pick-anchor').scrollIntoView({block:'start',behavior:mobilePicker||matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    ui('.sb-catalogue-heading h2').setAttribute('tabindex','-1');
    ui('.sb-catalogue-heading h2').focus({preventScroll:true});
  }

  function reviewMix() {
    if(matchMedia('(max-width:900px)').matches)openTray();
    else {
      ui('.sb-summary').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      ui('.sb-purchase input:checked').focus({preventScroll:true});
    }
  }

  function changePortion(name, delta) {
    if (busy || changing) return;
    const item = items.find(x => x.name===name);
    if (!item || !item.available) return;
    const wasChecked = item.input.checked;
    const quantity = selected.get(name)?.quantity || 0;
    const next = Math.max(0,quantity+delta);
    if (next === quantity) return;
    if (delta>0 && portionCount()>=rules().max) {
      announce(`Your ${variant.weight} mix has all ${rules().max} picks. Remove one to swap it.`);
      return;
    }
    if (next) portions.set(name,next);
    else portions.delete(name);
    if (wasChecked !== (next>0)) item.input.click();
    sync(false);
    if (item.input.checked !== (next>0)) {
      announce('That sweet could not be changed. Please try again.');
      return;
    }
    ui('.sb-live').textContent=`${item.title} ${delta>0?'added':'removed'}. ${portionCount()} of ${rules().max} picks chosen. Repeats count towards your mix.`;
  }

  function sweetWindow(item, id, width) {
    if (catalogue && item.preview) {
      const shape = item.previewLayout;
      if (!shape?.box) return `<image href="${escape(item.preview)}" x="${-width/2}" y="${-width}" width="${width}" height="${width}" preserveAspectRatio="xMidYMid meet"/>`;
      const [x,y,w,h] = shape.box, height = width*h/w;
      const clip = shape.kind==='clip' && shape.path ? `<defs><clipPath id="${id}" clipPathUnits="userSpaceOnUse"><path d="${escape(shape.path)}" clip-rule="evenodd"/></clipPath></defs>` : '';
      const artwork = `<svg x="${-width/2}" y="${-height}" width="${width}" height="${height}" viewBox="${x} ${y} ${w} ${h}" overflow="hidden">${clip}<image href="${escape(item.preview)}" x="0" y="0" width="100" height="${100/(shape.atlasRatio||1)}" ${clip?`clip-path="url(#${id})"`:''}/></svg>`;
      return shape.elongate ? `<g transform="translate(0 ${-height/2}) rotate(45) scale(1.7 1) rotate(-45) translate(0 ${height/2})">${artwork}</g>` : artwork;
    }
    const profile = window.SE_PILE_CLIPS?.[item.name.trim()];
    // A changed catalogue photo must never inherit a crop from a different image.
    if (!profile || !item.url.includes(profile.source)) {
      return `<image href="${escape(item.url)}" x="-25" y="-50" width="50" height="50" preserveAspectRatio="xMidYMid slice"/>`;
    }
    const clean = cleanSweets[item.name.trim()];
    if (clean) {
      const [x,y,w,h] = clean.box, height = width*h/w;
      const artwork = `<svg x="${-width/2}" y="${-height}" width="${width}" height="${height}" viewBox="${x} ${y} ${w} ${h}" overflow="hidden"><image href="${packingAsset(clean.asset)}" x="0" y="0" width="100" height="${100/(clean.atlasRatio||1)}"/></svg>`;
      return item.name.trim()==='Strawberry Pencils'
        ? `<g transform="translate(0 ${-height/2}) rotate(45) scale(1.7 1) rotate(-45) translate(0 ${height/2})">${artwork}</g>`
        : artwork;
    }
    const [x,y,w,h] = profile.box;
    const height = width * h / w;
    return `<svg x="${-width/2}" y="${-height}" width="${width}" height="${height}" viewBox="${x} ${y} ${w} ${h}" overflow="visible"><defs><clipPath id="${id}" clipPathUnits="userSpaceOnUse"><path d="${profile.path}" clip-rule="evenodd"/></clipPath></defs><image href="${escape(item.url)}" x="0" y="0" width="100" height="100" preserveAspectRatio="xMidYMid slice" clip-path="url(#${id})"/></svg>`;
  }

  function renderPile() {
    for (const name of pileOrder.keys()) if (!selected.has(name)) pileOrder.delete(name);
    for (const name of selected.keys()) if (!pileOrder.has(name)) pileOrder.set(name, ++pileSequence);
    const pack = variant.pack;
    const packageChanged = pilePack !== pack;
    const signature = `${pack}:${variant.weight}:` + [...pileOrder].map(([name,id]) => `${id}:${name}:${selected.get(name).quantity}`).join('|');
    const count = selected.size;
    ui('.sb-package-title').textContent = `Your ${variant.weight} ${pack}`;
    ui('.sb-pile-count').textContent = count ? `${portionCount()} of ${rules().max} picks` : 'Ready for your favourites';
    ui('.sb-pile-preview').classList.toggle('has-sweets',count>0);
    ui('.sb-pile-preview').dataset.pack = pack;
    ui('.sb-pile-caption').textContent = count ? 'Picked by you. Packed by us.' : 'Pick your first sweet below.';
    if (signature === pileSignature) return;
    pileSignature = signature;
    const isPouch = pack === 'pouch';
    const capacity = {'500g':60,'1kg':88,'1.5kg':132,'2kg':176}[variant.weight] || 88;
    const ground = isPouch ? 280 : 284;
    ui('#sb-package-content').setAttribute('transform',`translate(0 ${285-ground})`);
    for (const [selector,geometry] of [
      ['.sb-pack-cast-shadow',{cx:isPouch?291:295,cy:ground+4,rx:isPouch?126:224,ry:isPouch?17:22}],
      ['.sb-pack-contact-shadow',{cx:280,cy:ground,rx:isPouch?96:202,ry:isPouch?5:7}]
    ]) for (const [key,value] of Object.entries(geometry)) ui(selector).setAttribute(key,value);
    const image = isPouch ? {file:'pouch-studio-v2-700.webp',x:130,y:0,width:300,height:300} : {file:'box-studio-v3-1000.webp',x:20,y:-22,width:520,height:347};
    ui('.sb-pack-outline').setAttribute('d',isPouch
      ? 'M170 39 Q280 0 390 39 L378 267 L369 267 Q349 280 327 280 H231 Q213 277 202 274 L182 267 Z'
      : 'M115 5 H445 Q455 6 461 15 Q473 29 474 40 Q476 47 472 52 L462 59 L484 218 L485 281 Q485 284 481 285 H79 Q75 284 75 281 L75 220 L97 60 L89 52 Q84 47 86 38 Q89 24 97 16 Q107 6 115 5 Z');
    const windowPath = isPouch
      ? 'M181 78 Q280 91 379 78 L370 265 Q280 287 190 265 Z'
      : 'M125 0 H435 V67 L466 222 H94 L125 67 Z';
    const insidePath = isPouch
      ? 'M181 0 H379 V78 L370 265 Q280 287 190 265 L181 78 Z'
      : windowPath;
    ui('.sb-pack-interior-path').setAttribute('d',insidePath);
    ui('.sb-pack-window').setAttribute('d',windowPath);
    for (const el of uis('.sb-pack-back,.sb-pack-front,.sb-pack-film')) {
      el.setAttribute('href',packingAsset(image.file));
      for (const key of ['x','y','width','height']) el.setAttribute(key,image[key]);
    }
    ui('.sb-pack-film').style.display = isPouch ? '' : 'none';
    ui('.sb-pack-film').setAttribute('clip-path','url(#sb-pack-interior)');
    const scene = ui('.sb-pile-pieces');
    const motion = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    const existing = new Map([...scene.children].map(el => [el.dataset.piece,el]));
    const sweets = [...pileOrder].map(([name,id]) => ({...selected.get(name),id}));
    const parts = portionCount();
    const fill = Math.min(1,parts/rules().max);
    const total = count ? Math.max(count,Math.round(capacity*fill)) : 0;
    const columns = isPouch ? 6 : 11;
    const spacing = isPouch ? 30 : 32;
    const step = isPouch ? 20 : ({'1kg':17,'1.5kg':13,'2kg':10.5}[variant.weight] || 17);
    const base = isPouch ? 270 : 227;
    const addedNames = new Set(sweets.filter(sweet => sweet.quantity>(pileQuantities.get(sweet.name)||0)).map(sweet => sweet.name));
    const newest = Math.max(0,...pileOrder.values());
    ui('.sb-pile-preview').dataset.fill = String(total);
    const wanted = new Set();
    const allocated = new Map(sweets.map(sweet => [sweet.id,0]));
    let animated = 0;
    for (let index=0; index<total; index++) {
      const deficit = item => (index+1)*(1+(total-count)*item.quantity/parts)/total-allocated.get(item.id);
      const sweet = sweets.reduce((best,item) => !best || deficit(item)>deficit(best) ? item : best,null);
      const copy = allocated.get(sweet.id);
      allocated.set(sweet.id,copy+1);
      const key = `${sweet.id}-${copy}`; wanted.add(key);
      const row = Math.floor(index/columns), column = index%columns;
      const position = (column*5+row*3)%columns;
      const jitter = ((sweet.id*17+copy*11)%13)-6;
      const rowSpacing = isPouch ? spacing : spacing-row*.65;
      const x = 280 + (position-(columns-1)/2)*rowSpacing + jitter + (row%2 ? 4 : -2);
      const y = base-row*step + ((sweet.id+copy*3)%9)-4;
      const angle = ((sweet.id*29+copy*47)%121)-60;
      const profile = window.SE_PILE_CLIPS?.[sweet.name.trim()];
      const shape = catalogue ? sweet.previewLayout : cleanSweets[sweet.name.trim()] || profile;
      const ratio = shape?.box ? shape.box[2]/shape.box[3] : 1;
      const longEdge = (/Giant|Yellow Bellies|Chew Bar/.test(sweet.title) ? 55 : (isPouch ? 43 : 46)) + ((sweet.id+copy*7)%7)-3;
      const width = ratio<1 ? longEdge*ratio : longEdge;
      let piece = existing.get(key);
      const isNew = !piece;
      if (isNew) {
        piece = document.createElementNS('http://www.w3.org/2000/svg','g');
        piece.dataset.piece = key; piece.dataset.sweetName = sweet.name;
        piece.classList.add('sb-pile-piece');
        scene.append(piece);
      }
      if (isNew || packageChanged) piece.innerHTML = `<g class="sb-pile-sweet">${sweetWindow(sweet,`sb-clip-${key}`,width)}</g>`;
      if (isNew && (addedNames.has(sweet.name) || sweet.id===newest) && animated<3 && motion && !packageChanged) {
        const entryX = 280-x + jitter*2;
        const drop = piece.firstElementChild.animate([
          {transform:`translate(${entryX}px,${-y+20}px) rotate(${-angle}deg)`,opacity:0},
          {transform:`translate(${entryX*.4}px,${-y*.5}px) rotate(${-angle*.4}deg)`,opacity:1,offset:.3},
          {transform:'translate(0,0) rotate(0deg)',opacity:1,offset:.78},
          {transform:'translate(0,-4px) rotate(2deg)',opacity:1,offset:.89},
          {transform:'translate(0,0) rotate(0deg)',opacity:1}
        ],{duration:540,delay:animated++*45,easing:'cubic-bezier(.28,.12,.5,1)',fill:'backwards'});
        drop.finished.catch(()=>{});
      }
      piece.style.transform=`translate(${x}px,${y}px) rotate(${angle}deg)`;
      piece.dataset.row=String(row);
    }
    for (const [key,piece] of existing) if (!wanted.has(key)) piece.remove();
    [...scene.children].sort((a,b)=>Number(b.dataset.row)-Number(a.dataset.row)).forEach(piece=>scene.append(piece));
    if (packageChanged && motion && pilePack) {
      ui('.sb-pile-scene').animate([{opacity:.3,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'ease-out'});
    }
    pileQuantities = new Map(sweets.map(sweet => [sweet.name,sweet.quantity]));
    pilePack = pack;
  }

  async function changeSize(id) {
    if (busy || changing || String(variant.id)===id) return;
    const next=sizes.find(v=>String(v.id)===id);
    if (!next) return;
    const groups=catalogue.groups;
    const nextGroup=groups[sizes.indexOf(next)];
    if (!nextGroup) {announce('Size options are still loading. Please try again.');return;}
    const nextRules=readRules(nextGroup), keep=[...selected.keys()], keepPortions=new Map(portions);
    if (portionCount()>nextRules.max) {
      const excess=portionCount()-nextRules.max;
      announce(`Remove ${excess} ${excess===1?'pick':'picks'} before changing to ${next.weight}. Your current mix is saved.`);
      return;
    }
    const missing=keep.filter(name=>![...nextGroup.querySelectorAll('input[type="checkbox"]')].some(x=>x.value===name && !x.disabled));
    if (missing.length) {
      announce(`${label(missing[0])}${missing.length>1?` and ${missing.length-1} more`:''} isn’t offered in ${next.weight}. Remove ${missing.length===1?'it':'these'} first, or keep your current size.`);
      return;
    }
    changing=true;root.classList.add('is-changing');renderSummary();
    const select=nativeSelect();select.value=next.value;select.dispatchEvent(new Event('change',{bubbles:true}));
    for(let i=0;i<30;i++) {
      await sleep(100);
      if(visibleGroup()?.id===nextGroup.id && nativeForm()?.querySelector('input[name="id"]')?.value===String(next.id)) break;
    }
    group=visibleGroup();
    if(group?.id!==nextGroup.id || nativeForm()?.querySelector('input[name="id"]')?.value!==String(next.id)) {
      changing=false;root.classList.remove('is-changing');sync(true);announce('The size change did not finish. Please refresh before continuing.');return;
    }
    const inputs=[...group.querySelectorAll('input[type="checkbox"]')];
    inputs.filter(input=>input.checked && !keep.includes(input.value)).forEach(input=>input.click());
    inputs.filter(input=>!input.checked && keep.includes(input.value)).forEach(input=>input.click());
    await sleep(60);
    portions.clear();
    for (const [name,quantity] of keepPortions) portions.set(name,quantity);
    changing=false;root.classList.remove('is-changing');sync(true);
    announce(`${next.weight} selected. Choose ${rules().max} picks. Repeats count too.`);
  }

  async function addToBag() {
    if (busy || changing) return;
    if (catalogue) {
      busy=true; renderSummary();
      try { await catalogue.refresh(); pileSignature=''; pilePack=''; }
      catch (error) { busy=false; renderSummary(); announce(error.message || 'Sweet availability could not be checked. Nothing was added.'); return; }
      busy=false; sync(true);
      if (portionCount()!==rules().max) { announce('Sweet availability has changed. Please review your picks before adding your mix.'); return; }
    }
    sync(false);
    const picks = selectedPicks(), count = picks.length;
    if (count!==rules().max) return;
    const currentPlan = purchaseMode==='subscribe' ? subscriptionPlan() : null;
    if (purchaseMode==='subscribe' && !currentPlan) {announce('This subscription is unavailable. Please choose a one-time purchase or refresh.');return;}
    const currentPurchasePrice = purchasePrice();
    const form = nativeForm();
    const fresh = parseItems();
    if (!form || form.querySelector('input[name="id"]')?.value!==String(variant.id) || picks.some(pick=>!fresh.some(item=>item.name===pick.name && item.available))) {
      announce('Your options have changed. Please refresh before adding your mix.');return;
    }
    if ([...selected.values()].some(item=>Number(item.input.dataset.price||0)!==0 || item.input.dataset.sku || Number(item.input.dataset.weight||0)!==0)) {
      announce('This sweet’s options have changed. Please refresh before adding your mix.');return;
    }
    const payload = new FormData(form);
    payload.set('id',String(variant.id));
    payload.set('quantity','1');
    payload.delete('selling_plan');
    if (currentPlan) payload.set('selling_plan',String(currentPlan.id));
    for (const key of [...payload.keys()]) {
      if (/^properties\[(?:_?Sweet pick \d+|_?Choose Up To \d+ Sweets|_Sweet catalogue picks|_Mix builder)\]$/.test(key)) payload.delete(key);
    }
    const recipe = recipeSummary();
    payload.set('properties[Your sweets]',recipe);
    busy=true;renderSummary();
    const currentVariant=variant;
    let before;
    try {const response=await fetch('/cart.js',{cache:'no-store'});if(!response.ok)throw new Error();before=await response.json();}
    catch {busy=false;renderSummary();announce('We couldn’t reach your bag. Nothing was added. Please try again.');return;}
    const pickProperty=(item,index)=>item.properties?.[`_Sweet pick ${index+1}`] ?? item.properties?.[`Sweet pick ${index+1}`];
    const matchesMix=item=>Number(item.variant_id)===Number(currentVariant.id) && String(item.selling_plan_allocation?.selling_plan?.id || '')===String(currentPlan?.id || '') && (
      item.properties?.['Your sweets'] === recipe ||
      (!item.properties?.['Your sweets'] && picks.every((pick,index)=>pickProperty(item,index)===(pick.orderValue || pick.name)) && !pickProperty(item,count))
    );
    const prior=before.items.filter(matchesMix).reduce((n,item)=>n+item.quantity,0);
    try {
      const response = await fetch('/cart/add.js',{method:'POST',body:payload,headers:{Accept:'application/json'}});
      if (!response.ok) {
        const error = await response.json().catch(()=>({}));
        busy=false;renderSummary();announce(error.description || 'Your mix could not be added. Please try again.');return;
      }
    } catch {}
    let added;
    for(let i=0;i<14;i++) {
      await sleep(i<3?350:700);
      try {
        const response=await fetch('/cart.js',{cache:'no-store'});if(!response.ok)continue;
        const cart=await response.json();
        if(cart.items.filter(matchesMix).reduce((n,item)=>n+item.quantity,0)>prior) {added=cart;break;}
      } catch {}
    }
    busy=false;renderSummary();
    if(!added) {announce('We couldn’t confirm the addition. Check your bag before trying again.');return;}
    closeTray();
    showMixConfirmation(currentVariant,currentPurchasePrice,currentPlan);
    document.querySelectorAll('cart-icon').forEach(cartIcon=>cartIcon.renderCartBubble?.(added.item_count));
    const cartCount=document.querySelector('.se-cart-count');if(cartCount)cartCount.textContent=`(${added.item_count})`;
  }

  function prepareConfirmation() {
    const dialog=ui('.sb-confirm');
    dialog.classList.add('sb-confirm-reveal');
    dialog.setAttribute('aria-describedby','sb-confirm-detail');
    const stage=ui('.sb-confirm-stage') || ui('.sb-confirm-picks');
    stage.className='sb-confirm-stage';
    stage.setAttribute('aria-hidden','true');
    stage.innerHTML='<div class="sb-confirm-confetti"></div><svg class="sb-confirm-pack" viewBox="65 -5 430 315"><use href="#sb-package-content"/></svg><div class="sb-confirm-seal">'+icon('check')+'</div>';
    ui('.sb-confirm-symbol')?.remove();
    dialog.insertBefore(stage,ui('#sb-confirm-title'));
    ui('.sb-confirm-detail').id='sb-confirm-detail';
  }

  function showMixConfirmation(addedVariant,price,plan) {
    const dialog=ui('.sb-confirm');
    const stage=ui('.sb-confirm-stage');
    dialog.dataset.pack=addedVariant.pack;
    stage.querySelector('svg.sb-confirm-pack').setAttribute('viewBox',addedVariant.pack==='pouch'?'140 0 280 302':'65 -5 430 315');
    ui('.sb-confirm-detail').textContent=`${addedVariant.weight} ${addedVariant.pack} · ${money(price)}${plan ? ` · ${deliveryFrequency==='monthly'?'Every month':'Every 2 weeks'}` : ''}`;
    const confetti=ui('.sb-confirm-confetti');
    confetti.replaceChildren();
    if(!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const colours=['#fc5c98','#65bbdf','#fff8db','#3693c5','#ffb5d0'];
      for(let index=0;index<26;index++) {
        const piece=document.createElement('i');
        const side=index%2 ? 1 : -1;
        piece.style.cssText=`--x:${side*(40+(index*37)%140)}px;--y:${-65-(index*29)%110}px;--fall:${40+(index*23)%100}px;--turn:${side*(160+(index*47)%380)}deg;--delay:${(index%5)*22}ms;--colour:${colours[index%colours.length]};--origin:${index%2?'66%':'34%'};--angle:${index*43}deg`;
        piece.dataset.shape=String(index%3);
        confetti.append(piece);
      }
    }
    dialog.showModal();
  }

  function closeTray() {ui('.sb-drawer').close();ui('.sb-tray-toggle').setAttribute('aria-expanded','false');}
  function bind() {
    root.addEventListener('click',event=>{
      const button=event.target.closest('button');if(!button)return;
      if(button.dataset.increase)changePortion(button.dataset.increase,1);
      if(button.dataset.decrease)changePortion(button.dataset.decrease,-1);
      if(button.dataset.removePick!==undefined) {const pick=selectedPicks()[Number(button.dataset.removePick)];if(pick)changePortion(pick.name,-1);}
      if(button.dataset.size)changeSize(button.dataset.size);
      if(button.dataset.category) {
        category=button.dataset.category;
        uis('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        renderGrid();
      }
      if(button.classList.contains('sb-reset')) {
        category='all';
        uis('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category==='all')));renderGrid();
      }
      if(button.classList.contains('sb-add')) {if(button.dataset.sbAction==='pick')goToSweets();else if(button.dataset.sbAction==='review')reviewMix();else addToBag();}
      if(button.dataset.step==='sweets')goToSweets();
      if(button.dataset.step==='size') {closeTray();ui('.sb-size-options').scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});ui('.sb-size[aria-pressed=true]').focus({preventScroll:true});}
      if(button.dataset.step==='review')reviewMix();
      if(button.classList.contains('sb-tray-toggle'))openTray();
      if(button.classList.contains('sb-close-drawer'))closeTray();
      if(button.matches('.sb-close-confirm,.sb-keep-picking'))ui('.sb-confirm').close();
    });
    root.addEventListener('change',event=>{
      if(event.target.matches('[data-purchase-mode]')) {purchaseMode=event.target.value;renderSummary();}
      if(event.target.matches('[data-frequency]')) {deliveryFrequency=event.target.value;renderSummary();}
    });
    ui('.sb-confirm').addEventListener('close',()=>ui('.sb-confirm-confetti').replaceChildren());
    ui('.sb-drawer').addEventListener('close',()=>ui('.sb-tray-toggle').setAttribute('aria-expanded','false'));
    uis('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}}));
  }
  let attempts=0;
  function tryMount() {
    if (mount()) {clearInterval(init);return;}
    if (++attempts<=150) return;
    clearInterval(init);
    const shell=document.querySelector('[data-se-builder-shell]');
    const status=shell?.querySelector('.sb-loading-status');
    if (!status) return;
    const copy=window.SE_BUILDER_LOADING_COPY || {failed:'The sweet choices are taking longer to load.',refresh:'Refresh sweet choices',contact:'Contact us',contactUrl:'/pages/contact'};
    status.innerHTML=`${escape(copy.failed)}<span class="sb-load-recovery"><button type="button" data-sb-retry>${escape(copy.refresh)}</button><button type="button" data-sb-contact>${escape(copy.contact)}</button></span>`;
    shell.setAttribute('aria-busy','false');
    status.querySelector('[data-sb-retry]').addEventListener('click',()=>location.reload());
    status.querySelector('[data-sb-contact]').addEventListener('click',()=>location.assign(copy.contactUrl || '/pages/contact'));
  }
  const init=setInterval(tryMount,100);
  tryMount();
})();
